import { InboxOutlined } from '@ant-design/icons';
import { Button, DatePicker, Form, Modal, Select, Upload } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from "react-toastify";
import { updatedocumentForm } from '../../redux/rtk/features/document/documentSlice';


const { Dragger } = Upload;

// Update Modal Component
const UpdateDocumentModal = ({ visible, onCancel, record }) => {
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState([]);
    const dispatch = useDispatch();
  
    const handleFileChange = ({ fileList }) => {
      setFileList(fileList);
      console.log("Selected fileList:", fileList);
    };
  
    const onFinish = async (values) => {
      if (!fileList.length) {
        toast.error('Please upload a document before submitting.');
        return;
      }
  
      const formData = {
        ...values,
        documentProof: fileList[0]?.originFileObj,
      };
  
      if (values.expireDate) {
        formData.expireDate = values.expireDate.format('YYYY-MM-DD');
      }
  
      const response = await dispatch(updatedocumentForm({
        id: record.id,
        values: formData,
      }));
  
      if (response.payload.message === 'success') {
        onCancel();
        form.resetFields();
        setFileList([]);
        toast.success('Document updated successfully!');
      } else {
        toast.error('Failed to update document.');
      }
    };
  
    React.useEffect(() => {
      if (record) {
        form.setFieldsValue({
          documentType: record.documentType,
          documentName: record.documentName,
          expireDate: record.expireDate ? moment(record.expireDate) : null,
        });
      }
    }, [record, form]);
  
    return (
      <Modal
        title="Update Document"
        visible={visible}
        onCancel={onCancel}
        footer={null}
        width={800}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            label="Document Type"
            name="documentType"
            rules={[{ required: true, message: 'Please select document type' }]}
          >
            <Select>
              <Select.Option value="Aadhar">Aadhar</Select.Option>
              <Select.Option value="PAN">PAN</Select.Option>
              <Select.Option value="10th Certificate">10th Certificate</Select.Option>
              <Select.Option value="12th Certificate">12th Certificate</Select.Option>
              <Select.Option value="Other">Other</Select.Option>
            </Select>
          </Form.Item>
  
          {form.getFieldValue('documentType') === 'Expired Document' && (
            <Form.Item
              label="Expire Date"
              name="expireDate"
              rules={[{ required: true, message: 'Please select expire date' }]}
            >
              <DatePicker />
            </Form.Item>
          )}
  
          <Form.Item
            label="Upload New Document"
            name="documentProof"
            rules={[{ required: true, message: 'Please upload a document' }]}
          >
            <Dragger
              listType="picture-card"
              fileList={fileList}
              onChange={handleFileChange}
              beforeUpload={() => false}
              maxCount={1}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-hint">
                Click or drag file to upload document
              </p>
            </Dragger>
          </Form.Item>
  
          <Form.Item className="text-right">
            <Button type="primary" htmlType="submit">
              Update Document
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    );
  };
  
  export default UpdateDocumentModal;
  
